// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"766d6e39","551":"023872c1","842":"06cc87c2"}[chunkId] + ".chunk.js";
};